import Vue from 'vue'
import Vuex from 'vuex'
import storage from '@/utlis/storage'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    phone: '',
    password: '',
    token: '', // 存储 token
    uuid: '',
    userInfo: {},
    redirectPath: ''
  },

  getters: {
    getToken (state) {
      return state.token || storage.get('token') || ''
    },
    getUuid (state) {
      return state.uuid || storage.get('uuid') || ''
    },
    getUserInfo (state) {
      return state.userInfo || storage.get('userInfo') || {}
    },
    getRedirectPath (state) {
      return state.redirectPath || storage.get('redirectPath') || ''
    }
  },

  mutations: {
    setToken (state, token) {
      state.token = token
      storage.set('token', token)
      console.log('store、localstorage保存token成功！')
    },

    delToken (state) {
      state.token = ''
      storage.remove('token')
    },

    setUuid (state, uuid) {
      state.uuid = uuid
      storage.set('uuid', uuid) // 将 uuid 存储到 localStorage
      console.log('store、localstorage保存uuid成功！')
    },

    delUuid (state) {
      state.uuid = ''
      storage.remove('uuid') // 删除 uuid
    },

    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
      storage.set('userInfo', userInfo)
    },

    delUserInfo (state) {
      state.userInfo = {}
      storage.remove('userInfo') // 删除 uuid
    },

    setRedirectPath (state, redirectPath) {
      state.redirectPath = redirectPath
    },

    delRedirectPath (state) {
      state.redirectPath = {}
      storage.remove('redirectPath') // 删除 uuid
    }

  },

  actions: {
  },

  modules: {
  }
})

export default store
